export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  useGrouping: true, // Add a comma as the grouping separator
  currencySign: 'accounting',
});

export const detailedCurrencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: true, // Add a comma as the grouping separator
  currencySign: 'accounting', // use parentheses for negative numbers
});

const largeFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  // useGrouping: true, // Add a comma as the grouping separator
  // currencySign: 'accounting',
});

// Update the formatter for values over $1M
const detailedLargeFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export const largeCurrencyFormatter = (value) => {
  const formatter = largeFormatter;
  if (Math.abs(value) >= 1e9) {
    // Format in billions (B)
    return `${formatter.format(value / 1e9)}B`;
  }
  if (Math.abs(value) >= 1e6) {
    // Format in millions (M) with one decimal place
    return `${detailedLargeFormatter.format(value / 1e6)}M`;
  }
  if (Math.abs(value) >= 1e3) {
    // Format in thousands (k)
    return `${formatter.format(value / 1e3)}k`;
  }
  // Format as is
  return formatter.format(value);
};
